<template>
  <v-container fluid>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" small>
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Add data manually</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <h2 class="red--text" v-if="getWeekday(ITEM.DATE) != 1">
                  Not Monday!
                </h2>
                Starting date: {{ ITEM.DATE }}<br />
                Ruoka_0 and Ruoka_1 are separated by new line. <br />
                New day is separeted by empty line.<br /><br />
                <b>Price of AI: {{ aiTotatlPrice }} USD</b>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <v-col cols="4" class="pa-0 ma-0">
                    <v-btn color="primary" class="pa-4 ma-0" @click="useAI">
                      Use Ai
                      <v-icon class="pl-1">mdi-auto-fix</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="8" class="pa-0 ma-0">
                    <v-select
                      label="Model"
                      :items="models"
                      v-model="default_model"
                      variant="solo-filled"
                      class="pa-0 ma-0"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" class="pa-0 ma-0">
                    <v-textarea
                      label="Prompt"
                      v-model="PROMPT"
                      required
                      outlined
                      row-height="1"
                      rows="1"
                      class="pa-1 ma-1"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-if="getWeekday(ITEM.DATE) != 1"
                  label="Huomio, että kyseessä ei ole maanantai!"
                  v-model="DATA"
                  required
                  outlined
                  color="red"
                  row-height="15"
                  rows="20"
                ></v-textarea>
                <v-textarea
                  v-else
                  label="DATA"
                  v-model="DATA"
                  required
                  outlined
                  row-height="15"
                  rows="20"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-spacer></v-spacer>
          <p class="red--text">{{ ERROR_MSG }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveData"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "adddatamanual",
  props: ["DATELIST", "ITEM"],
  data() {
    return {
      dialog: false,
      DATE: "",
      RESTAURANT: "",
      TYPE: "",
      POS: "",
      URL: "",
      Ruoka_0: "",
      Ruoka_1: "",
      Ruoka_2: "",
      Ruoka_3: "",
      ERROR_MSG: "",
      DATA: "",
      models: [
        "anthropic.claude-3-5-sonnet-20240620-v1:0",
        "anthropic.claude-3-sonnet-20240229-v1:0",
        "anthropic.claude-v2",
        "anthropic.claude-instant-v1",
      ],
      default_model: "anthropic.claude-3-5-sonnet-20240620-v1:0",
      aiResponse: {},
      aiTotatlPrice: 0,
      PROMPT: `Your task is to convert food menus into specific format. All of the food menus are written in Finnish language and you must always response with Finnish. Below there are some guidelines that you should follow.
- Add food allergens with capital letters in the end of each row. For example G,L,M
- Always remove parantheses.
- Always start every row with capital letter. All other characters should be written in lowercase.
- Write "Tietoa ei löytynyt." if you are not sure what you should write.
- Remove excess information such as name of the day, date and price.
- Put food menu of Monday inside of <ma> XML tag and food menu of Tuesday inside <ti> tag and so on.
- If there are multiple food options available for a single day, place the options into their own rows.
- Raw text is found inside <text> XML tags.

<example>
H:MA 5.2.

Juuressosekeitto L,G

Kanaa talon tapaan

Salamipasta  VL              

Kasvistäytteinen paprika L,G

TI 6.2.

Bataatti-linssikeitto L,G

Lihamureke ruskeakastike L,G

Lohipyörykät L,G kylmäkastike G            

Porkkanapyörykät L,G

KE 7.2.

AAMIAINEN klo 8-9.30     5,50€/ 10€

Jauhelihakeitto L,G

Paneroitua kanansisäfileetä L currymajoneesi

Savuporokiusaus L,G                   

Lehtikaali-härkäpapupihvi L

TO 8.2.

Juustoinen kukkakaalikeitto L,G

Ylikypsää possun ulkofileetä BBQkastike L,G

Paneroitua turskaa & ranskalaiset L            

Punajuurta & vuohenjuustoa L,G

PE 9.2.

Keltainen porkkanasosekeitto L,G

Bearnaisekanaa G

Nakkipannu L,G                   

Kasviswokki L

LA 10.2.

Linssimureke L

kana pihvit G

SU 9.2.

Pippuripihvi L

Metsästäjänleike G

A:
<ma>
Juuressosekeitto L,G
Kanaa talon tapaan
Salamipasta  VL
Kasvistäytteinen paprika L,G
</ma>

<ti>
Bataatti-linssikeitto L,G
Lihamureke ruskeakastike L,G
Lohipyörykät L,G kylmäkastike G
Porkkanapyörykät L,G
</ti>

<ke>
AAMIAINEN klo 8-9.30
Jauhelihakeitto L,G
Paneroitua kanansisäfileetä L currymajoneesi
Savuporokiusaus L,G
Lehtikaali-härkäpapupihvi L
</ke>

<to>
Juustoinen kukkakaalikeitto L,G
Ylikypsää possun ulkofileetä BBQkastike L,G
Paneroitua turskaa & ranskalaiset L
Punajuurta & vuohenjuustoa L,G
</to>

<pe>
Keltainen porkkanasosekeitto L,G
Bearnaisekanaa G
Nakkipannu L,G
Kasviswokki L
</pe>

<la>
Linssimureke L
Kana pihvit G
</la>

<su>
Pippuripihvi L
Metsästäjänleike G
</su>
</example>

<text></text>`,
    };
  },
  methods: {
    processData(data) {
      data = data + "\n"; // add new line in the end, incase that is missed from the text
      var data_items = data.split("\n");
      var items = [];
      var item = {};
      var food_num = 0;
      var date_list_index = this.DATELIST.indexOf(this.ITEM.DATE);

      for (var i in data_items) {
        var food = "Ruoka_" + food_num.toString();

        if (data_items[i].length < 2) {
          // Fill foods, so that there are at least 4 foods
          while (food_num < 4) {
            food = "Ruoka_" + food_num.toString();
            item[food] = "";
            food_num += 1;
          }

          // Add standard stuff
          item["CITY_RESTAURANT"] = this.ITEM.CITY_RESTAURANT;
          item["CITY"] = this.ITEM.CITY;
          item["URL"] = this.ITEM.URL;
          item["DATE"] = this.DATELIST[date_list_index];
          item["TYPE"] = this.ITEM.TYPE;
          item["POS"] = this.ITEM.POS;

          // Only add new ite item if it is having valid data
          if (item["Ruoka_0"] !== "") {
            items.push(item);
            date_list_index += 1; // get next date
          }

          food_num = 0; // Init food_num index
          item = {}; // Init new item
        } else {
          item[food] = data_items[i];
          food_num += 1;
        }
      }
      return items;
    },
    saveData() {
      var items = this.processData(this.DATA);
      console.log(items);
      var response;
      var item;
      for (var i in items) {
        item = items[i];
        console.log("SAVE ", item);
        response = this.$emit("post-data", item);
        this.$emit("refresh-data", item);
        console.log("RESPONSE: ", response);
      }
      this.dialog = false;
    },
    getWeekday(date) {
      // Date in YYYY-MM-DD
      // return number 0 = sunday, 1 = monday
      var d = moment(date);
      var wd = d.day();
      return wd;
    },
    useAI() {
      var data = this.DATA;
      var prompt = this.PROMPT;
      var modelId = this.default_model;
      console.log("PROMPT: ", prompt);
      console.log("DATA: ", data);
      console.log("MODEL: ", modelId);
      this.postApiData({ PROMPT: prompt, TEXT: data, MODEL_ID: modelId });
    },
    handleAiResponse(data) {
      console.log(data);
      this.aiTotatlPrice = data.body.total_price;
      this.DATA = data.body.generated_text;
    },
    postApiData(item) {
      var response, url;
      url = this.$store.state.api_url + "ai";
      console.log(url);
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.$store.state.token,
        },
        body: JSON.stringify(item),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log(data);
            this.aiResponse = data;
            this.handleAiResponse(data);
          } else {
            alert(
              "Server returned " + response.status + " : " + response.statusText
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
p {
  font-size: 10px;
}
a {
  color: #0067a7 !important;
  text-decoration: none;
  font-size: 16px;
}
a:hover {
  color: #0c0c0c;
  text-decoration: underline;
}

.lunch-table-header {
  text-align: center;
  background-color: #e6e6e6;
}

thead {
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #e9ecef;
  border: 1px solid #e9ecef;
  padding: 4px;
}

th {
  border-bottom-width: 2px;
  vertical-align: top;
  border-bottom: 2px solid #e9ecef;
  border: 1px solid #e9ecef;
  padding: 4px;
}

td {
  border: 1px solid #e9ecef;
  padding-left: 10px;
}

table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.01rem;
  background-color: transparent;
  border-collapse: collapse;
  border: 1px solid #e9ecef;
  display: table;
  white-space: normal;
  line-height: normal;
  font-weight: normal;
  font-size: medium;
  font-style: normal;
  color: -internal-quirk-inherit;
  text-align: start;
  border-spacing: 2px;
  font-variant: normal;
}

.w-66 {
  width: 66% !important;
}
.w-33 {
  width: 33% !important;
}
</style>
